module.exports = __webpack_public_path__ + "img/mcb-1.89d4f693.gif";